// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "bootstrap"

global.$ = require("jquery")
require("jquery")
require("jquery-ui")
require("@nathanvda/cocoon")
require("easy-autocomplete")
require("bootstrap-datepicker")

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import "packs/medicine"
import "packs/medicine-unit"
import "packs/global-search"
import "packs/prescription-preview"
import "packs/preset"

document.addEventListener("turbolinks:load", function () {
  $('.datepicker').datepicker({
    format: 'yyyy/mm/dd'
  });
});

import "controllers"
